import {takeLatest, put, call} from 'redux-saga/effects';
import apiCall from '../../api';
import {DELETE_GROWTH_PATH_ERROR, DELETE_GROWTH_PATH_START, DELETE_GROWTH_PATH_SUCCESS} from "../../types";

export function* deleteGP({payload}) {
    try {
        const url = `/growthpath/${payload.id}/`;
        const method = 'DELETE';
        const headers = {Authorization: 'Bearer ' + payload.token, 'Content-Type':'application/json'};
        const results = yield call(apiCall, url, method, payload.formData, headers);
        yield put({type: DELETE_GROWTH_PATH_SUCCESS, results: results.data});
        yield put(payload.navigate('/app/content-management/manage-growth-path'));
    } catch (error) {
        yield put({type: DELETE_GROWTH_PATH_ERROR, error});
    }
}

export default function* delete_growth_path() {
    yield takeLatest(DELETE_GROWTH_PATH_START, deleteGP);
}